import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, type TypedUseSelectorHook, useSelector } from 'react-redux';

import { stepsSlice } from './stepsSlice';
import { plansSlice } from './plansSlice';
import { userSlice } from './userSlice';
import { notificationsSlice } from './notificationsSlice';
import { submitSlice } from './submitSlice';
import { couponSlice } from './couponSlice';
import { initSlice } from './initSlice';
import { featureFlagsSlice } from '@/store/featureFlagsSlice';

export const store = configureStore({
  reducer: {
    [initSlice.name]: initSlice.reducer,
    [stepsSlice.name]: stepsSlice.reducer,
    [plansSlice.name]: plansSlice.reducer,
    [userSlice.name]: userSlice.reducer,
    [notificationsSlice.name]: notificationsSlice.reducer,
    [submitSlice.name]: submitSlice.reducer,
    [couponSlice.name]: couponSlice.reducer,
    [featureFlagsSlice.name]: featureFlagsSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
